import { peek, selector } from 'lib/selectors'
import { StateInterface } from 'types/state'
import { EducationTypeImmutable } from 'pages/Profile/WorkExperienceEducation/types'

const education = (state: StateInterface) => state.education
const educationsListRaw = selector(education, peek('educationsList'))

export const educationsListSelector = (state: StateInterface) => {
  const list = educationsListRaw(state)
  if (!list || list.isEmpty()) return list

  return list.sort((a: EducationTypeImmutable, b: EducationTypeImmutable) => {
    const toA = a.get('to') || -1
    const toB = b.get('to') || -1
    // -1 means "present" (still studying), should be at top
    if (toA === -1 && toB !== -1) return -1
    if (toB === -1 && toA !== -1) return 1
    // Sort descending (most recent first)
    return toB - toA
  })
}

export const educationSelector = selector(education, peek('education'))
